// import { CheckIcon, LinkIcon, UploadIcon, XIcon } from '@primer/octicons-react';
// import { Box, Link, TextInput } from '@primer/react';

// import { useEffect, useMemo, useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { foThucDonApi } from '../../../api/foThucDonApi';
// import { uploadApi } from '../../../api/uploadApi';
// import { appInfo } from '../../../AppInfo';
// import { AnimationPopup } from '../../../components/modal';
// import { PopUpForm, PopUpFormActions } from '../../../components/pop-up-form/PopUpForm';
// import Button from '../../../components/ui/button';
// import DataTable from '../../../components/ui/data-table';
// import { useCommonContext } from '../../../contexts/common';
// import { NotifyHelper } from '../../../helpers/toast';
// import { RootState } from '../../../state/reducers';
// import styles from './ImportHocSinhModal.module.css';
// import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
// import { hocSinhApi } from '../../../api/hocSinhApi';

// interface IThucDonImportModalProps {
//     onClose: () => void;
//     animationOf: string;
// }

// const ImportHocSinhModal = (props: IThucDonImportModalProps) => {
//     const { translate } = useCommonContext();
//     const { animationOf, onClose } = props;
//     const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
//     const [uploadedFileName, setUploadedFileName] = useState<string>("");
//     const [isLoading, setIsLoading] = useState<boolean>(false);
//     const componentDidMount = useRef<boolean>(false);
//     const [dataSouce, setDataSouce] = useState<any[]>([]);
//     const [dataSouceValidated, setDataSouceValidated] = useState<any[]>([]);

//     const notValidCount = useMemo<number>(() => {
//         return dataSouceValidated.filter((x) => x["Thông tin lỗi"] !== "").length;
//     }, [dataSouceValidated]);
//     const handleSelectFile = () => {
//         const input = document.createElement('input');
//         input.setAttribute('type', 'file');
//         input.setAttribute(
//             'accept',
//             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
//         );
//         input.click();
//         input.onchange = async () => {
//             var file = input && input.files ? input.files[0] : null;
//             if (file) {
//                 const res = await uploadApi.uploadExcel(file)
//                 if (res.is_success) {
//                     setUploadedFileName(res.data.fileNameId)
//                 } else {
//                     NotifyHelper.Error(res.message ?? "Error")
//                 }
//             }
//         };
//         input.remove();
//     };
//     useEffect(() => {
//         componentDidMount.current = true;
//         if (uploadedFileName !== "") {
//             setIsLoading(true);
//             handleReadUploadedFile();
//             setIsLoading(false);
//         }
//     }, [uploadedFileName]);

//     const handleReadUploadedFile = async () => {
//         setIsLoading(true);
//         const res = await uploadApi.readExcel({
//             fileName: uploadedFileName,
//             sheetIndex: 0,
//         });

//         if (!componentDidMount.current) return;
//         setIsLoading(false);

//         if (res.is_success) {
//             setDataSouce(res.data);
//         }
//         await handleValidateImportFile();
//     };
//     const handleValidateImportFile = async () => {
//         setIsLoading(true);
//         const datasend = {
//             fileName: uploadedFileName,
//             sheetIndex: 0
//         }
//         const res = await hocSinhApi.ValidateImportHocSinh(datasend,nam_hoc, dm_coso_id);
//         if (!componentDidMount.current) return;
//         if (res.is_success) {
//             setDataSouceValidated(res.data);
//         }
//         setIsLoading(false);
//     };
//     const hanldeImport = async () => {
//         setIsLoading(true);
//         const datasend = {
//             fileName: uploadedFileName,
//             sheetIndex: 0
//         }
//         const res = await hocSinhApi.ImportHocSinh(datasend,nam_hoc, dm_coso_id);
//         if (!componentDidMount.current) return;
//         setIsLoading(false);
//         if (res.is_success) {
//             NotifyHelper.Success("Success!");
//         } else {
//             NotifyHelper.Error("Error")
//         }
//         onClose();
//     };
//     const columns = useMemo(() => {
//         if (!dataSouceValidated || dataSouceValidated.length === 0) return [];
//         const keys = Object.keys(dataSouceValidated[0]).filter((key) => key !== "0" && key !== "ID");

//         return [
//             ...keys.map((key) => ({
//                 dataField: key,
//                 caption: key,
//             })),
//         ];
//     }, [dataSouceValidated]);
//     return (
//         <>
//             <AnimationPopup
//                 animationOf={animationOf}
//                 width={"80%"}
//                 title='Import học sinh '
//                 onClose={onClose}
//             >
//                 <Box sx={{
//                     overflow: "hidden",
//                     display: "flex",
//                     flexDirection: "column",
//                     maxHeight: "85vh",
//                 }}>
//                     <Box sx={{
//                         display: "flex",
//                     }}>
//                         <Box>

//                         </Box>
//                         <div className={styles.actions}>
//                             <div className={styles.action_item}>
//                                 <Button leadingVisual={UploadIcon} text='Upload file' onClick={handleSelectFile}
//                                     size='medium'
//                                 />
//                             </div>
//                             {uploadedFileName &&
//                                 <TextInput sx={{ ml: 2, width: 400 }} value={uploadedFileName} readOnly />
//                             }
//                             <Box className={styles.action_item} sx={{ flex: 1 }}>
//                             </Box>
//                             <Box>
//                                 <Link href={`${appInfo.baseApiURL.replace('/api', '')}/TEMPLATE/IMPORT_HOCSINH.xlsx`} target='_blank'>
//                                     <Button sx={{ color: 'blue' }} text={`${translate(`Tải mẫu import học sinh tại đây`)}`}
//                                         variant='invisible'
//                                         leadingVisual={LinkIcon}
//                                     />
//                                 </Link>

//                             </Box>
//                         </div>
//                     </Box>
//                     <Box>
//                         <DataTable
//                             data={dataSouceValidated}
//                             isLoading={isLoading}
//                             paging={{ enable: true }}
//                             columns={columns}
//                             height={`${window.innerHeight - 340}px`}

//                         />
//                     </Box>
//                     <Box>
//                         <PopUpFormActions>
//                             <Button leadingVisual={XIcon} text='Base.Label.Close' onClick={onClose} />
//                             <Button
//                                 leadingVisual={CheckIcon}
//                                 variant='primary'
//                                 isLoading={isLoading}
//                                 text={'ThoiKhoaBieuImport.Label.Save'}
//                                 //disabled={notValidCount > 0}
//                                 onClick={hanldeImport}
//                             ></Button>
//                         </PopUpFormActions>
//                     </Box>
//                 </Box>
//             </AnimationPopup>
//         </>
//     );
// };

// export default ImportHocSinhModal;

import { CheckIcon, DownloadIcon, LinkIcon, UploadIcon, XIcon } from "@primer/octicons-react";
import { Box, FormControl, Link, TextInput } from '@primer/react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { uploadApi } from '../../../api/uploadApi';
import { hocSinhApi } from '../../../api/hocSinhApi';
import { appInfo } from '../../../AppInfo';
import { AnimationPopup } from '../../../components/modal';
import DataTable from '../../../components/data-table/DataTable';
import { PopUpForm, PopUpFormActions } from '../../../components/pop-up-form/PopUpForm';
import Steps, { IStepData } from '../../../components/steps/Steps';
import Button from '../../../components/ui/button';
import { useCommonContext } from '../../../contexts/common';
import { NotifyHelper } from '../../../helpers/toast';
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";

interface IImportHocSinhModalProps {
    dm_truong_id: number;
    nam_hoc: string;
    onClose: () => void;
    animationOf: string;
}

const _steps: IStepData[] = [
    {
        id: 1,
        name: "Upload file",
        is_active: true
    },
    {
        id: 2,
        name: "Validate",
        is_active: false
    },
    {
        id: 3,
        name: "Import",
        is_active: false
    }
];

const ImportHocSinhModal = (props: IImportHocSinhModalProps) => {
    const { translate } = useCommonContext();
    const { onClose, animationOf, dm_truong_id } = props;
    
    const [stepId, setStepId] = useState(1);
    const [uploadedFileName, setUploadedFileName] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const componentDidMount = useRef<boolean>(false);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [dataSourceValidated, setDataSourceValidated] = useState<any[]>([]);
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();

    const notValidCount = useMemo<number>(() => {
      return dataSourceValidated.filter((x) => x.ma_loi !== undefined && x.ma_loi !== "").length;
  }, [dataSourceValidated]);
  
    const handleSelectFile = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute(
            'accept',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
        );
        input.click();
        input.onchange = async () => {
            var file = input && input.files ? input.files[0] : null;
            if (file) {
                setIsLoading(true);
                const res = await uploadApi.uploadExcel(file);
                if (res.is_success) {
                    setUploadedFileName(res.data.fileNameId);
                    setStepId(2);
                } else {
                    NotifyHelper.Error(res.message ?? "Error");
                }
                setIsLoading(false);
            }
        };
        input.remove();
    };

    useEffect(() => {
        componentDidMount.current = true;
        if (uploadedFileName !== "") {
            handleReadUploadedFile();
        }
        return () => {
            componentDidMount.current = false;
        };
    }, [uploadedFileName]);

    const handleReadUploadedFile = async () => {
        setIsLoading(true);
        const res = await uploadApi.readExcel({
            fileName: uploadedFileName,
            sheetIndex: 0,
        });

        if (!componentDidMount.current) return;

        if (res.is_success) {
            setDataSource(res.data);
            await handleValidateImportFile();
        }
        setIsLoading(false);
    };

    const handleValidateImportFile = async () => {
      setIsLoading(true);
      const datasend = {
          fileName: uploadedFileName,
          sheetIndex: 0
      };
      const res = await hocSinhApi.ValidateImportHocSinh(datasend, nam_hoc, dm_coso_id);
      if (!componentDidMount.current) return;
      if (res.is_success) {
          console.log('Validated data:', res.data); // Thêm log này để xem cấu trúc dữ liệu
          setDataSourceValidated(res.data);
      }
      setIsLoading(false);
  };
  const handleImport = async () => {
    setIsLoading(true);
    const datasend = {
        fileName: uploadedFileName,
        sheetIndex: 0
    };
    const res = await hocSinhApi.ImportHocSinh(datasend, nam_hoc, dm_coso_id);
    if (!componentDidMount.current) return;
    if (res.is_success) {
        setStepId(4); // Chuyển sang bước 4 sau khi lưu thành công
        NotifyHelper.Success("Success!");
    } else {
        NotifyHelper.Error("Error");
    }
    setIsLoading(false);
};

    const columns = useMemo(() => {
        if (!dataSourceValidated || dataSourceValidated.length === 0) return [];
        const keys = Object.keys(dataSourceValidated[0]).filter((key) => key !== "0" && key !== "ID");

        return [
          {
            header: 'Kết quả',
            field: 'ma_loi',
            minWidth: "200px",
            renderCell: (data: any) => (
                <>
                    {data.err ? (
                        <FormControl.Validation variant='error'>
                            <Box sx={{ whiteSpace: "break-spaces" }} className='limit2Line'>
                                <Box style={{ whiteSpace: 'pre-line', textAlign: 'left' }}
                                    dangerouslySetInnerHTML={{ __html: data.ma_loi }}>
                                </Box>
                            </Box>
                        </FormControl.Validation>
                    ) : (
                        <FormControl.Validation variant='success' />
                    )}
                </>
            )
        },
            ...keys.map((key) => ({
                header: key,
                field: key,
                width: key === "STT" ? "80px" : "200px",
                rowHeader: key === "Mã học sinh"
            }))
        ];
    }, [dataSourceValidated]);

    return (
        <AnimationPopup
            animationOf={animationOf}
            width={"90%"}
            title='Import học sinh'
            onClose={onClose}
            
        >
            <Box sx={{
                overflowX: "scroll",
                display: "flex",
                flexDirection: "column",
                maxHeight: "85vh",
            }}>
                <Box>
                    <Steps steps={_steps.map(x => ({
                        ...x,
                        is_active: x.id === stepId
                    }))} />
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Box sx={{ display: "flex" }}>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <Button 
                                leadingVisual={UploadIcon} 
                                text='Upload file' 
                                onClick={handleSelectFile}
                                size='medium'
                                isLoading={isLoading}
                            />
                            {uploadedFileName && (
                                <TextInput 
                                    sx={{ width: 400 }} 
                                    value={uploadedFileName} 
                                    readOnly 
                                />
                            )}
                            <Box sx={{ flex: 1 }} />
                            <Link href={`${appInfo.baseApiURL.replace('/api', '')}/TEMPLATE/IMPORT_HOCSINH.xlsx`} target='_blank'>
                                <Button 
                                    text={translate('Tải mẫu import học sinh tại đây')}
                                    variant='invisible'
                                    leadingVisual={DownloadIcon}
                                />
                            </Link>
                        </div>
                    </Box>

                    {stepId >= 2 && (
                        <Box sx={{ mt: 3 }}>
                            <DataTable
                                data={dataSourceValidated}
                                isLoading={isLoading}
                                //paging={{ enable: true }}
                                columns={columns}
                                height={`${window.innerHeight - 340}px`}
                                titleComponent={
                                    <>
                                        {notValidCount > 0 && (
                                            <FormControl.Validation variant='error'>
                                                Có {notValidCount} dòng không hợp lệ
                                            </FormControl.Validation>
                                        )}
                                    </>
                                }
                            />
                        </Box>
                    )}
                </Box>

                <PopUpFormActions>
                    <Button 
                        leadingVisual={XIcon} 
                        text='Base.Label.Close' 
                        onClick={onClose} 
                    />
                    {stepId === 2 && (
                        <Button
                            leadingVisual={CheckIcon}
                            variant='primary'
                            isLoading={isLoading}
                            text={'ThoiKhoaBieuImport.Label.Save'}
                            onClick={handleImport}
                            disabled={notValidCount > 0}
                        />
                    )}
                </PopUpFormActions>
            </Box>
        </AnimationPopup>
    );
};

export default ImportHocSinhModal;